// removed by extract-text-webpack-plugin
module.exports = {"block":"_2WUQVy4isZNXwXqQRVCxeq","wrapper":"_1YQQD4rlulTFbn9yt4O18k","content":"_1hdBjPbXZYUdBh2Yn8zt0r","link":"qZXg_7MaC-gktHxd7521P","headingLink":"_3znZKWbdv9tPDmb1UFKSr4","heading":"_3_FFevfLQXA66bd82Gdman","image":"_2bd6wZ7p9w10pbWf4GgHhd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DepartmentInformationBlock/DepartmentInformationBlock.module.scss
// module id = 746
// module chunks = 0